import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./EditArticle.css";
import {
  getArticleById,
  updateArticleApi,
} from "../../../../services/Article/Article.service";
import { getCategoriess } from "../../../../services/Category/category.service";
import { getAllDesireds } from "../../../../services/DesiredType/DesiredType.service";
import { toast } from "react-toastify";

const EditArticle: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [articleName, setArticleName] = useState("");
  const [description, setDescription] = useState("");

  const [metalTypeId, setMetalTypeId] = useState<number | "">("");
  const [categoryId, setCategoryId] = useState<number | "">("");

  const [status, setStatus] = useState("Active");

  const [metalTypes, setMetalTypes] = useState<any[]>([]);
  const [allCategories, setAllCategories] = useState<any[]>([]);
  const [filteredCategories, setFilteredCategories] = useState<any[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ Filter category according to selected metal type
  useEffect(() => {
    if (metalTypeId) {
      const filtered = allCategories.filter(
        (item) => Number(item.metalTypeId) === Number(metalTypeId)
      );

      setFilteredCategories(filtered);

      // reset category if not matching
      const exists = filtered.find(
        (cat) => Number(cat.id) === Number(categoryId)
      );

      if (!exists) {
        setCategoryId("");
      }
    } else {
      setFilteredCategories([]);
      setCategoryId("");
    }
  }, [metalTypeId, allCategories]);

  const fetchData = async () => {
    if (!id) return;

    try {
      const article = await getArticleById(id);

      const metalsResponse = await getAllDesireds();
      const categoriesResponse = await getCategoriess();

      const metals = metalsResponse?.data || [];
      const cats = categoriesResponse || [];

      setMetalTypes(metals);
      setAllCategories(cats);

      // ✅ Set article data
      setArticleName(article.articleName || "");
      setDescription(article.description || "");
      setMetalTypeId(article.metalTypeId || "");
      setCategoryId(article.categoryId || "");
      setStatus(article.status || "Active");

      // ✅ Initial filter
      const filtered = cats.filter(
        (item: any) =>
          Number(item.metalTypeId) === Number(article.metalTypeId)
      );

      setFilteredCategories(filtered);

    } catch (error) {
      toast.error("Failed to load article");
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!id) return;

    if (!articleName.trim()) {
      toast.error("Article name is required");
      return;
    }

    if (!metalTypeId) {
      toast.error("Please select metal type");
      return;
    }

    if (!categoryId) {
      toast.error("Please select category");
      return;
    }

    try {
      await updateArticleApi(id, {
        articleName,
        description,
        metalTypeId: Number(metalTypeId),
        categoryId: Number(categoryId),
      });

      toast.success("Article updated successfully");

      navigate("/article/list");
    } catch (error) {
      toast.error("Failed to update article");
    }
  };

  return (
    <div className="edit-article-container">
      <h2>Edit Article</h2>

      <form onSubmit={handleSubmit}>
        {/* Article Name */}
        <input
          type="text"
          value={articleName}
          placeholder="Article Name"
          onChange={(e) => setArticleName(e.target.value)}
        />

        {/* Metal Type */}
        <select
          value={metalTypeId}
          onChange={(e) => {
            setMetalTypeId(Number(e.target.value));
          }}
        >
          <option value="">Select Metal Type</option>

          {metalTypes.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Category */}
        <select
          value={categoryId}
          onChange={(e) => setCategoryId(Number(e.target.value))}
        >
          <option value="">Select Category</option>

          {filteredCategories.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Description */}
        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        {/* Status */}
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>

        <div className="button-close">
          <button
            type="button"
            onClick={() => navigate("/article/list")}
          >
            Close
          </button>

          <button type="submit">
            Update Article
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditArticle;